import { RestService, Rest } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import type { AnswerDto } from '../answers/models';
import type { CommentCalibrationAnswerDto } from '../evaluations/calibrations/answers/models';
import type { CalibrationViewUpdateDto } from '../evaluations/calibrations/models';
import type { AnswerQuestionInputDto, EvaluationDto, FinishEvaluationInputDto, PagedRequestEvaluationDto } from '../evaluations/models';
import type { PagedResultDto } from '../pagination/models';

@Injectable({
  providedIn: 'root',
})
export class CalibrationService {
  apiName = 'Default';
  

  answerCalibrationQuestionByInput = (input: AnswerQuestionInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, AnswerDto>({
      method: 'POST',
      url: '/api/app/calibration/answer-calibration-question',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  finishCalibrationByInput = (input: FinishEvaluationInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: '/api/app/calibration/finish-calibration',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  getEvaluationInformationForCalibrationByCalibrationEvaluationInstanceId = (calibrationEvaluationInstanceId: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, CalibrationViewUpdateDto>({
      method: 'GET',
      url: `/api/app/calibration/evaluation-information-for-calibration/${calibrationEvaluationInstanceId}`,
    },
    { apiName: this.apiName,...config });
  

  getEvaluationsForCalibrationByInputAndIsCurrentUserEvaluator = (input: PagedRequestEvaluationDto, isCurrentUserEvaluator: boolean, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<EvaluationDto>>({
      method: 'GET',
      url: '/api/app/calibration/evaluations-for-calibration',
      params: { evaluateeId: input.evaluateeId, evaluateeName: input.evaluateeName, state: input.state, startDate: input.startDate, endDate: input.endDate, areaId: input.areaId, subAreaId: input.subAreaId, shiftId: input.shiftId, isOperatorEvaluationSummaryFlow: input.isOperatorEvaluationSummaryFlow, skipCount: input.skipCount, maxResultCount: input.maxResultCount, isCurrentUserEvaluator },
    },
    { apiName: this.apiName,...config });
  

  setCalibrationCommentByInput = (input: CommentCalibrationAnswerDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: '/api/app/calibration/set-calibration-comment',
      body: input,
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
